import product1 from '../../images/product-1.jpg';
import product2 from '../../images/product-2.jpg';
import product3 from '../../images/product-3.jpg';
import sweet1 from '../../images/sweet3.jpg';
import sweet2 from '../../images/sweet-2.jpg';
import sweet3 from '../../images/sweet-3.jpg';

export const productData = [
    {
        img: product1,
        alt: 'Pizza',
        name: 'Supreme Pizza',
        desc: 'Marinara Sauce, basil, italian sausage, roma tomatoes, olives, and pesto',
        price: '$19.99',
        button: 'Add to Cart'
    },
    {
        img: product2,
        alt: 'Pizza',
        name: 'Hawaiian Paradise',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eros lectus, gravida id mauris eu.',
        price: '$19.99',
        button: 'Add to Cart'
    },{
        img: product3,
        alt: 'Pizza',
        name: 'Veggie Overload',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eros lectus, gravida id mauris eu.',
        price: '$19.99',
        button: 'Add to Cart'
    }
]

export const productDataTwo = [
    {
        img: sweet2,
        alt: 'Donuts',
        name: 'Doughlicious',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eros lectus, gravida id mauris eu.',
        price: '$19.99',
        button: 'Add to Cart'
    },
    {
        img: sweet3,
        alt: 'Ice Cream',
        name: 'Caramel Wonder',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eros lectus, gravida id mauris eu.',
        price: '$19.99',
        button: 'Add to Cart'
    },{
        img: sweet1,
        alt: 'Brownie',
        name: 'Brownie Bunch',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eros lectus, gravida id mauris eu.',
        price: '$19.99',
        button: 'Add to Cart'
    }
]